App.addModule(function(app) {

    app.on('form:submitted', (form, ok) => {
        
        if (ok && form.id === 'coupon-form') {
            
            const data = new FormData(form)

            if (data.get('remove')) {
                app.dispatchEvent('coupon:remove')
	        }
	        else {
                app.dispatchEvent('coupon:apply', data.get('coupon_code'))
	        }
        }
    })
})
